import { LocationAlias } from "./location-alias.model";

export class LocationAliasMapper {
  public static map(data: any): LocationAlias {
    if (!data) {
      return null;
    }

    return new LocationAlias(data.id, data.name);
  }
}
